import React, { useState } from 'react';
import { WixCapitalDealerBanner as WixCapitalDealerBannerUI } from '@wix/app-market-components';
import { useWixCapitalDealerBanner } from '../../hooks/use-wix-capital-dealer-banner';
import { OneStepInstallationModal } from '../one-step-installation-modal';

const DEALER_BANNER_ORIGIN = 'dealer-app-market';

export function WixCapitalDealerBanner() {
  const { assets, appId, parsedCtaUrl, onPrimaryCtaClick } =
    useWixCapitalDealerBanner();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePrimaryCtaClick = () => {
    onPrimaryCtaClick();
    if (appId) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <WixCapitalDealerBannerUI
        assets={assets ?? undefined}
        parsedCtaUrl={parsedCtaUrl}
        onPrimaryCtaClick={handlePrimaryCtaClick}
      />
      {appId && (
        <OneStepInstallationModal
          appId={appId}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          origin={DEALER_BANNER_ORIGIN}
        />
      )}
    </>
  );
}
